import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export interface IEstimate {
  activeCoverage?: string
  appointmentTypeEntityList?: Array<{
    appointmentCode?: string
    deleted?: boolean
    description?: string
  }>
  createdAt: string
  dependentSearch?: boolean
  dob?: string
  firstName?: string
  gender?: string
  id?: number
  lastName?: string
  middleInitial?: string
  physicianCode?: string
  physicianId?: number
  physicianName?: string
  relationship?: string
}

export interface EstimateData {
  content?: any[]
  empty?: boolean
  first?: boolean
  last?: boolean
  number?: number
  numberOfElements?: number
  pageable?: {
    offset?: number
    pageNumber?: number
    pageSize?: number
    paged?: boolean
    unpaged?: boolean
    sort?: {
      empty?: boolean
      sorted?: boolean
      unsorted?: boolean
    }
  }
  sort?: {
    empty?: boolean
    sorted?: boolean
    unsorted?: boolean
  }
  totalElements: number
  totalPages: number
}

export type EstimatesAction =
  | ActionType<typeof actions.createEstimateRequest>
  | ActionType<typeof actions.createEstimateSuccess>
  | ActionType<typeof actions.createEstimateFail>
  | ActionType<typeof actions.createPublicEstimateRequest>
  | ActionType<typeof actions.createPublicEstimateSuccess>
  | ActionType<typeof actions.createPublicEstimateFail>
  | ActionType<typeof actions.fetchEstimatesRequest>
  | ActionType<typeof actions.fetchEstimatesSuccess>
  | ActionType<typeof actions.fetchEstimatesFail>
  | ActionType<typeof actions.fetchEstimateRequest>
  | ActionType<typeof actions.fetchEstimateSuccess>
  | ActionType<typeof actions.fetchEstimateFail>
  | ActionType<typeof actions.getPDFOnEmailRequest>
  | ActionType<typeof actions.getPDFOnEmailSuccess>
  | ActionType<typeof actions.getPDFOnEmailFail>
  | ActionType<typeof actions.getPDFRequest>
  | ActionType<typeof actions.getPDFSuccess>
  | ActionType<typeof actions.getPDFFail>

export interface EstimatesState {
  isFetchingCreate: boolean
  isFetching: boolean
  data: EstimateData
  estimate: {} | IEstimate
  PDF: string
  error: boolean
  isFetchingCreatePublic: boolean
  publicEstimate: any
}

export enum EstimatesActionTypes {
  CREATE_ESTIMATE_REQUEST = '@@auth/CREATE_ESTIMATE_REQUEST',
  CREATE_ESTIMATE_SUCCESS = '@@auth/CREATE_ESTIMATE_SUCCESS',
  CREATE_ESTIMATE_FAIL = '@@auth/CREATE_ESTIMATE_FAIL',
  CREATE_PUBLIC_ESTIMATE_REQUEST = '@@auth/CREATE_PUBLIC_ESTIMATE_REQUEST',
  CREATE_PUBLIC_ESTIMATE_SUCCESS = '@@auth/CREATE_PUBLIC_ESTIMATE_SUCCESS',
  CREATE_PUBLIC_ESTIMATE_FAIL = '@@auth/CREATE_PUBLIC_ESTIMATE_FAIL',
  FETCH_ESTIMATES_REQUEST = '@@auth/FETCH_ESTIMATES_REQUEST',
  FETCH_ESTIMATES_SUCCESS = '@@auth/FETCH_ESTIMATES_SUCCESS',
  FETCH_ESTIMATES_FAIL = '@@auth/FETCH_ESTIMATES_FAIL',
  FETCH_ESTIMATE_REQUEST = '@@auth/FETCH_ESTIMATE_REQUEST',
  FETCH_ESTIMATE_SUCCESS = '@@auth/FETCH_ESTIMATE_SUCCESS',
  FETCH_ESTIMATE_FAIL = '@@auth/FETCH_ESTIMATE_FAIL',
  GET_PDF_REQUEST = '@@auth/GET_PDF_REQUEST',
  GET_PDF_SUCCESS = '@@auth/GET_PDF_SUCCESS',
  GET_PDF_FAIL = '@@auth/GET_PDF_FAIL',
  GET_PDF_ON_EMAIL_REQUEST = '@@auth/GET_PDF_ON_EMAIL_REQUEST',
  GET_PDF_ON_EMAIL_SUCCESS = '@@auth/GET_PDF_ON_EMAIL_SUCCESS',
  GET_PDF_ON_EMAIL_FAIL = '@@auth/GET_PDF_ON_EMAIL_FAIL'
}
